import { Component } from "react";

class Question extends Component {
    state = {}
    render(){
        return (
            <div className="col-12 question">
                <h2>{this.props.title}</h2>
            </div>
        );
    }
}

export default Question;